export const editorPages = [
  { path: '', label: 'Home' },
  { path: '/therapists', label: 'Our Therapists' },
  { path: '/blog', label: 'Blog & Resources' },
  { path: '/insurance', label: 'Insurance' },
  { path: '/book-appointment', label: 'Book Appointment' },
];

export const editorCollections = [
  { key: 'services', label: 'Services', path: '/services' },
  { key: 'specialties', label: 'Specialties', path: '/specialty' },
  { key: 'blogPosts', label: 'Blog posts', path: '/blog' },
];
